// extracted by mini-css-extract-plugin
export var button = "_jp-0";
export var donut = "_jp-1";
export var donutFill = "_jp-3";
export var donutTrack = "_jp-2";